import { render, staticRenderFns } from "./PortalDocumentosExterno.vue?vue&type=template&id=8b556744"
import script from "./PortalDocumentosExterno.vue?vue&type=script&lang=js"
export * from "./PortalDocumentosExterno.vue?vue&type=script&lang=js"
import style0 from "./PortalDocumentosExterno.vue?vue&type=style&index=0&id=8b556744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports